import { render, staticRenderFns } from "./service-program-apply.vue?vue&type=template&id=12387bcd&"
import script from "./service-program-apply.vue?vue&type=script&lang=js&"
export * from "./service-program-apply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports